<template>
  <span v-html="link" ></span>
</template>

<script>
  import Vue from 'vue';

  /**
   * Replaced by BicItemRefSplit tht use router component
   * 
   * Get the desc of the bicref 
   * "You can also use #$0 or #$1 or something else",
   * and replaced every #$n by a link generated according to 
   * the type of the ref (industry, division, class, bic)
   */
  export default Vue.component('BicItemRef', {
    props: {
      bicref: Object,
      getAlternateBicForSource: Function,
    },
    computed: {
      link: function() {
        if (this.bicref.refs) {
          const mapRefs = this.mapRefs(this.bicref.refs);
          return this.bicref.desc.replace(/\#\$(\d+)/gi, function(matched){
            return mapRefs[matched];
          });
        }
        return this.bicref.desc; // some alternate code don't have a link so the description is displayed as is.
      },
    },
    // Add eventListener to hyperlinks. Because of the way the links are generated (string)
    // the click event handler has to be added after the component is mounted.
    // Links to "browse" (industry, division, class) will be handled y the routing 
    // but link to bic 
    mounted: function() {
      const eventHandler = this.test;
      this.$el.querySelectorAll('a.ref-link-bic').forEach(function (element) {
        element.addEventListener('click', this.refBicDisplay);
      }.bind(this));
    },
    methods: {
      // transforms and array of bic refs into an object 
      //  { "#$0": link0, "#$1": link1, "#$2": link2 }
      mapRefs: function(refs) {
        return refs.reduce((acc, cur, index) => {
          const key = `#$${index}`;
          const type = cur.type.toLowerCase();
          const link = `<a class="ref-link-${type}" data-ref-id="${cur.id}" href="/browse/${type}/${cur.id}"
            data-gtm-category="Cross Reference" data-gtm-action="${cur.type}" data-gtm-label="${cur.desc}">${cur.desc}</a>`;
          return Object.assign(acc, { [key]: link });
        }, {});
      },
      refBicDisplay: function(event) {
        event.preventDefault();
        const link = event.target;
        const id = link.getAttribute('data-ref-id');
        this.getAlternateBicForSource({ id });
        // console.log(id);
      }
    }
  });
</script>